import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children, allowedRoles = null }) => {
  // Read env flag (sync) and auth state (hooks) unconditionally
  const bypass = process.env.REACT_APP_BYPASS_AUTH === 'true';
  const token = useSelector(state => state.auth?.token);
  const user = useSelector(state => state.auth?.user);

  // Allow bypass during UI work via env flags
  if (bypass) return children;

  // If no token, redirect to login
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // If allowedRoles provided, ensure user has at least one of the roles
  if (allowedRoles) {
    const roles = Array.isArray(user?.roles) ? user.roles : [];
    const hasRole = roles.some(r => allowedRoles.includes(r));
    // if (!hasRole) return <Navigate to="/login" replace />; // or an unauthorized page
  }

  return children;
};

export default ProtectedRoute;
